import { render } from "./talent.vue?vue&type=template&id=b1171400&ts=true"
import script from "./talent.vue?vue&type=script&lang=ts"
export * from "./talent.vue?vue&type=script&lang=ts"

import "./talent.vue?vue&type=style&index=0&id=b1171400&lang=scss"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__